import { Permission } from './permission.model';

export interface Role {
  id: number;
  name: string;
  displayName: string;
  displayNameKey?: string;
  description?: string;
  descriptionKey?: string;
  isSystemRole: boolean;
  isActive: boolean;
  createdDate: Date;
  updatedDate: Date;
  permissions?: Permission[];
  userCount?: number;
  level: number;
}

export interface RolePermission {
  id: number;
  roleId: number;
  permissionId: number;
  grantedDate: Date;
  grantedBy: number;
  isActive: boolean;
}

export interface RoleAssignment {
  id: number;
  userId: number;
  roleId: number;
  assignedDate: Date;
  assignedBy: number;
  expiresDate?: Date;
  isActive: boolean;
  reason?: string;
}

export enum SystemRole {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  MANAGER = 'manager',
  RESIDENT = 'resident',
  VENDOR = 'vendor',
  GUEST = 'guest',
}

export interface RoleHierarchy {
  id: number;
  parentRoleId: number;
  childRoleId: number;
  createdDate: Date;
  isActive: boolean;
}
